'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    {Dialog, FlatButton} = require('material-ui'),
    get = require('lodash/object').get,
     {delay} = require('lodash/function'),
    {concat} = require('lodash/array'),
    DEFAULT_LABEL_OK = t('password_recovery_primary_button'),
    DEFAULT_LABEL_CONFIRM = t('button_label_continue'),
    DEFAULT_LABEL_CANCEL = t('button_label_cancel');

const CustomDialog = React.createClass({displayName: "CustomDialog",

    getInitialState() {
        return {
            title: 'title_test',
            message: 'message_test',
            type: 'info'
        };
    },

    showInfo(title, message, labelOk) {
        this.show({
            title,
            message,
            labelOk: labelOk || t('ok'),
            type: 'info'
        });
    },

    showWarningConfirmation(title, message, onConfirm, labelConfirm, labelOk, onCancel, onClickAway) {
        this.show({
            title,
            message,
            labelConfirm,
            onConfirm,
            onCancel,
            labelOk: labelOk || t('ok'),
            type: 'warning',
            onClickAway
        });
    },

    show(params) {
        const title = get(params, 'title', '');
        const message = get(params, 'message', '');
        const type = get(params, 'type', 'info');
        const onConfirm = get(params, 'onConfirm');
        const onCancel = get(params, 'onCancel');
        const labelConfirm = get(params, 'labelConfirm');
        const labelOk = get(params, 'labelOk');
        const onClickAway = get(params, 'onClickAway');

        this.setState({
            title,
            message,
            onConfirm,
            onCancel,
            labelConfirm,
            labelOk,
            type,
            onClickAway
        }, () => {
            this.refs.customDialog.show();
            const self = this;
            if (this.refs.customDialog && this.refs.customDialog.getDOMNode()) {
                delay(() => {
                    const buttonEl = self.refs.customDialog.getDOMNode().querySelector('button');
                    if (buttonEl) {
                        buttonEl.focus();
                        buttonEl.scrollIntoView();
                    }
                }, 1000);

            }
        });
    },

    close() {
        this.refs.customDialog.dismiss();
    },

    getDefaultActions(onCancel, label, isPrimary = true) {
        let onCancelAction;

        if (onCancel) {
            onCancelAction = () => {
                if (onCancel) {
                    onCancel();
                }
                this.close();
            };
        } else {
            onCancelAction = this.close;
        }
        return [
            (
                React.createElement(FlatButton, {
                    label: label, 
                    primary: isPrimary, 
                    onTouchTap: onCancelAction
                }
                )
            )
        ];
    },

    getConfirmAction(onClick, label) {
        const onClickAfterClose = (onClickCallback) => {
            if (onClickCallback) {
                onClickCallback();
            }
            this.close();
        };
        return (
            React.createElement(FlatButton, {
                label: label, 
                primary: true, 
                onTouchTap: onClickAfterClose.bind(this, onClick)
            }
            )
        );
    },

    render() {
        const {message, title, onConfirm, labelConfirm, labelOk, onCancel, onClickAway} = this.state;
        let actionsWithClose;

        if (onConfirm) {
            actionsWithClose = this.getDefaultActions(onCancel, labelOk || DEFAULT_LABEL_CANCEL, false);
            actionsWithClose = concat(this.getConfirmAction(onConfirm, labelConfirm || DEFAULT_LABEL_CONFIRM), actionsWithClose);
        } else {
            actionsWithClose = this.getDefaultActions(onCancel, labelOk || DEFAULT_LABEL_OK);
        }

        return (
            React.createElement(Dialog, {
                ref: "customDialog", 
                title: title, 
                actions: actionsWithClose, 
                actionFocus: "submit", 
                modal: false, 
                onClickAway: onClickAway
            }, 
                React.createElement("div", null, 
                    React.createElement("div", {dangerouslySetInnerHTML: getMessage(message)})
                )
            )
        );
    }
});

function getMessage(message) {
    return {__html: message};
}

module.exports = CustomDialog;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Dialog/CustomDialog.js
 **/